import React from 'react';

const Footer: React.FC = () => {
  const footerSections = [
    {
      title: 'Producto',
      links: [
        { name: 'Características', href: '#features' },
        { name: 'Integraciones', href: '#integrations' },
        { name: 'Changelog', href: '#changelog' }
      ]
    },
    {
      title: 'Recursos',
      links: [
        { name: 'Roadmap', href: '#roadmap' },
        { name: 'Docs', href: '#docs' },
        { name: 'Ayuda', href: '#help' }
      ]
    },
    {
      title: 'Docs',
      links: [
        { name: 'API', href: '#api' },
        { name: 'Status', href: '#status' },
        { name: 'Guías', href: '#guides' }
      ]
    },
    {
      title: 'Empresa',
      links: [
        { name: 'Nosotros', href: '#about' },
        { name: 'Contacto', href: '#contact' },
        { name: 'Carreras', href: '#careers' }
      ]
    }
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {footerSections.map((section, index) => (
            <div key={index} className="footer-section">
              <h4>{section.title}</h4>
              <ul>
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <a href={link.href}>{link.name}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="footer-bottom">
          <div className="footer-copyright">
            © 2025 APOLOX. Todos los derechos reservados.
          </div>
          <div className="footer-social">
            <a href="#" aria-label="Twitter">𝕏</a>
            <a href="#" aria-label="GitHub">⚡</a>
            <a href="#" aria-label="LinkedIn">in</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;